/* eslint-disable no-unused-vars */
/* eslint-disable no-process-env */
import {PageLayout} from '@deere/fuel-react';
import {Helmet} from 'react-helmet-async';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {AnchorLink} from './components/AnchorLink';
import {useNavigationItems} from './hooks/useNavigationItems';
import Home from './pages/Home';
import {LoginCallback, Security} from '@okta/okta-react';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {RequiredAuth} from './routes/secure.route';
import {SessionReset} from './authentication/SessionReset';

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_ISSUER_OKTA,
    redirectUri: `${window.location.origin}/implicit/callback`,
    clientId: process.env.REACT_APP_CLIENT_ID_OKTA,
    pkce: Boolean(process.env.REACT_APP_OKTA_PKCE),
    devMode: Boolean(process.env.REACT_APP_OKTA_DEVMODE),
    responseType: 'code',
    scopes: JSON.parse(process.env.REACT_APP_SCOPES ?? '[]'),
    tokenManager: {
        autoRenew: true
    }
});

export function App() {
    const navigationItems = useNavigationItems();
    const navigate = useNavigate();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        navigate(toRelativeUrl(originalUri || '', window.location.origin));
    };

    return (
        <PageLayout
            HeaderProps={{
                HeaderLogoLinkComponent: AnchorLink,
                isContained: true,
                logoLink: '/',
                navigationItems,
                title: 'JDSN Contact Us',
                titleLink: '/'
            }}
        >
            <Helmet>
                <title>{'JDSN Contact Us'}</title>
            </Helmet>
            <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={restoreOriginalUri}
            >
                <Routes>
                    <Route
                        element={<LoginCallback/>}
                        path='/implicit/callback'
                    />
                    <Route
                        element={SessionReset}
                        path='/login'
                    />
                    <Route
                        element={<RequiredAuth/>}
                        path='/'
                    >
                        <Route
                            element={<RequiredAuth/>}
                            path='/'
                        >
                            <Route
                                element={<Home/>}
                                path=''
                            />
                        </Route>
                    </Route>
                </Routes>
            </Security>
        </PageLayout>
    );
}

export default App;
